var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Datepicker", {
    ref: "picker",
    attrs: {
      name: _vm.mergedOptions.name,
      id: _vm.mergedOptions.id,
      format: _vm.mergedOptions.format,
      language: _vm.mergedOptions.language,
      disabledDates: _vm.mergedOptions.disabledDates,
      placeholder: _vm.mergedOptions.placeholder,
      inline: _vm.mergedOptions.inline,
      inputClass: _vm.mergedOptions.inputClass,
      mondayFirst: _vm.mergedOptions.mondayFirst,
      required: _vm.mergedOptions.required,
      typeable: _vm.mergedOptions.typeable,
      disabled: _vm.mergedOptions.disabled,
      "clear-button": _vm.mergedOptions.clearButton,
      "clear-button-icon": _vm.mergedOptions.clearButtonIcon
    },
    model: {
      value: _vm.valueModel,
      callback: function($$v) {
        _vm.valueModel = $$v
      },
      expression: "valueModel"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }